export default {
  table: {
    date: 'Date of issue',
    type: 'Type file',
    name: 'Name',
    description: 'Description',
    title: 'New file'
  }
}
